const _ = require("underscore");
const Reflux = require("reflux");

const Tooltip = require("app/shared/components/Tooltip/tooltip");
const Icon = require("app/shared/components/Icon/icon");
const Dropdown = require("app/shared/components/Dropdown/dropdown");

const Card = require("../Dashboard/card");
const WithLoader = require("../Dashboard/with-loader");
const FunnelMovesTable = require("./funnel-moves-table");

const FunnelMovesStore = require("../../stores/funnel-moves-store");
const FunnelMovesActions = require("../../actions/funnel-moves-actions");

const Loader = WithLoader();

const FunnelMovesWidget = React.createClass({
  mixins: [Reflux.ListenerMixin],

  getInitialState: function() {
    return FunnelMovesStore.getInitialState();
  },

  componentDidMount: function() {
    this.listenTo(FunnelMovesStore, this.setState);

    FunnelMovesActions.loadFunnels();
  },

  componentDidUpdate: function(prevProps, prevState) {
    if (this.shouldRecalculateFunnels(prevProps, prevState)) {
      FunnelMovesActions.recalculateFunnels(this.state.funnels, this.props.funnel);
    }

    if (this.shouldRefresh(prevProps, prevState)) {
      this.refresh();
    }

    this.removeTooltips();
  },

  shouldRefresh: function(prevProps, prevState) {
    return (this.props != prevProps && this.props.funnel == prevProps.funnel) ||
      this.state.originFunnelId != prevState.originFunnelId ||
      this.state.destinationFunnelId != prevState.destinationFunnelId;
  },

  shouldRecalculateFunnels: function(prevProps, prevState) {
    return this.props.funnel != prevProps.funnel || this.state.funnels != prevState.funnels;
  },

  refresh: function() {
    if (
      !this.state.originFunnelId || !this.state.originFunnelId ||
      this.state.originFunnelId == this.state.destinationFunnelId
    ) return;

    FunnelMovesActions.fetchData(
      this.props.period,
      this.props.users,
      this.state.originFunnelId,
      this.state.destinationFunnelId
    );
  },

  removeTooltips: function () {
    this.refs.funnelMovesTooltips.innerHTML = "";
  },

  helpTooltipText: function () {
    let text = 'Este relatório informa os negócios que foram iniciados em um funil e depois movidos para outro funil.';
    text += '<br><br>As colunas Ganhos e Perdidos contabilizam o que foi concluído no segundo funil que chegou a partir do primerio funil.';

    return text;
  },

  getFunnelOptions: function() {
    if (!this.state.funnels.length) return [];

    let emptyOption = { id: null, name: "" };

    let options = _.map(this.state.funnels, function(funnel) {
      return { id: funnel.id, name: funnel.name };
    });

    return [emptyOption, ...options];
  },

  handleOriginChange: function(option) {
    if (!option.value) return;

    FunnelMovesActions.setOriginFunnelId(option.value);
  },

  handleDestinationChange: function(option) {
    if (!option.value) return;

    FunnelMovesActions.setDestinationFunnelId(option.value);
  },

  findFunnelById: function(funnelId) {
    return _.find(this.state.funnels, function(funnel) {
      return funnel.id == funnelId;
    });
  },

  render: function() {
    return (
      <Card
        className="grid-item-col-4"
        title={
          <p>Movimentações entre funis</p>
        }
      >
        {/*
         *
         * Os tooltips utilizados no `FunnelMovesTable` serão renderizados aqui para ser possível
         * remover todos eles através do método `removeTooltips`. Devido ao `FunnelMovesTable`
         * possuir uma renderização condicional, os tooltips utilizados nele estavam continuando
         * sendo exibidos caso eles estivessem "abertos" e a branch de renderização fosse trocada
         * durante isso. Antes, eles estavam utilizando o "body" como container.
         *
         */}
        <div id="funnel-moves-tooltip-container" ref='funnelMovesTooltips' />

        <div className="ta-c mb-15 fs-14">
          <div className="p-a">
            <Tooltip
              html
              right
              title={this.helpTooltipText()}
              container="#tooltip-container"
            >
              <Icon custom icon="help-circle" className="c-fontGray" />
            </Tooltip>
          </div>

          <Dropdown ref="origin-funnel"
            handleCustomChange={this.handleOriginChange}
            value={this.state.originFunnelId}
            options={this.getFunnelOptions()}
            className="b-light"
          />

          <Icon custom icon="arrow-right" className="va-mid ml-10 mr-10" />

          <Dropdown ref="destination-funnel"
            handleCustomChange={this.handleDestinationChange}
            value={this.state.destinationFunnelId}
            options={this.getFunnelOptions()}
            className="b-light"
          />
        </div>

        <Loader
          loading={this.state.loading || this.state.moves.loading}
          failed={this.state.moves.failed}
          onRetry={this.refresh}
        >
          <FunnelMovesTable
            originFunnel={this.findFunnelById(this.state.originFunnelId)}
            destinationFunnel={this.findFunnelById(this.state.destinationFunnelId)}
            data={this.state.moves.data}
            hasMultipleFunnels={this.state.funnels.length > 1}
            period={this.props.period}
          />
        </Loader>
      </Card>
    )
  }
});

module.exports = FunnelMovesWidget;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Widgets/funnel-moves-widget.jsx